async function loadEnv(): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `${window.location.origin}/__ENV.js`;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load __ENV.js"));
    document.head.appendChild(script);
  });
}

async function bootstrap() {
  try {
    await loadEnv();
    const { startApp } = await import("./AppEntry");
    startApp();
  } catch (error) {
    console.error(error);
    // Optionally display an error UI
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML =
        "<div>Failed to load environment. Please try again later.</div>";
    }
  }
}

bootstrap();
